import Axios from 'axios'
import store from '../store'

export default {
  getClientId () {
    return store.getters['Client/clientId']
  },
  protect (event, allRecurrenceEvents) {
    return Axios.put(`api/internal/clients/${this.getClientId()}/users/${event.email}/events/${event.eventId}/protect`, { 'allRecurrenceEvents': allRecurrenceEvents })
  },
  unprotect (event, allRecurrenceEvents) {
    return Axios.put(`api/internal/clients/${this.getClientId()}/users/${event.email}/events/${event.eventId}/unprotect`, { 'allRecurrenceEvents': allRecurrenceEvents })
  }
}
